export default
    {
        "Name": "LayoutLandscapeSpectate",
        "tablePosition": "spectate",
        "background": { x: -200, y: -200, width: 800 + 400, height: 500 + 400, zOrder: -100 },
        "hand1": { x: 340 + 50, y: 350 + 70, r: 0, offsetX: 101, offsetY: 0, selectedOffsetY: -20, maxWidth: 360, width: 100, height: 140, offsetR: 0, showfront: true, randomZOrder: true, pileStyle: "center" },
        "hand2": { x: 340 + 50, y: 10 + 70, r: 0, offsetX: 101, offsetY: 0, selectedOffsetY: -5, maxWidth: 360, width: 100, height: 140, offsetR: 0, showfront: true, randomZOrder: true, pileStyle: "center" },
        "handShow1": { x: 340 + 50 - 90, y: 350 + 70, r: 0, offsetX: 101, offsetY: 0, maxWidth: 120, width: 100, height: 140, offsetR: 0, showfront: false, pileStyle: "center" },
        "handShow2": { x: 340 + 50 - 90, y: 10 + 70, r: 0, offsetX: 101, offsetY: 0, maxWidth: 120, width: 100, height: 140, offsetR: 0, showfront: false, pileStyle: "center" },
        "cribShow1": { x: 340 + 50 + 100, y: 350 + 70, r: 0, offsetX: 101, offsetY: 0, maxWidth: 120, width: 100, height: 140, offsetR: 0, showfront: false, pileStyle: "center" },
        "cribShow2": { x: 340 + 50 + 100, y: 10 + 70, r: 0, offsetX: 101, offsetY: 0, maxWidth: 120, width: 100, height: 140, offsetR: 0, showfront: false, pileStyle: "center" },
        "buttonScoreHand1": { x: 340 + 50, y: 350 + 70 },
        "buttonScoreHand2": { x: 340 + 50, y: 10 + 70 },
        "buttonScoreCrib1": { x: 340 + 50, y: 180 + 70 },
        "buttonScoreCrib2": { x: 340 + 50, y: 180 + 70 },
        "buttonScoreAnalyzer1": { x: 430, y: 350 + 100 },
        "buttonScoreAnalyzer2": { x: 430, y: 10 + 100 },
        "cribstaging1": { x: 260, y: 250, offsetX: 70, offsetY: 0, showfront: true, pileStyle: "basic" },
        "cribstaging2": { x: 525, y: 250, offsetX: -70, offsetY: 0, showfront: true, pileStyle: "basic" },
        "crib1": { x: 165, y: 360, r: 0, offsetX: 2, offsetY: 1, scale: 0.2, showfront: true, pileStyle: "basic" },
        "crib2": { x: 165, y: 20, r: 0, offsetX: 2, offsetY: 1, scale: 0.2, showfront: true, pileStyle: "basic" },
        "play": { x: 205 + 50, y: 180 + 70 + 2, offsetX: 30, offsetY: 0, pileStyle: "staggard", staggerY: -4, staggerPlayer: "player2", mergePile: "played", offsetXMergedPile: 20, offsetXGap: 30 },
        "playBackground": { x: 205 + 1000, y: 180, width: 300, height: 140, alpha: 0.3, zOrder: -90 },
        "played": { grayedOut: true },
        "deck": { x: 130, y: 250, offsetX: 0.1, offsetY: -0.1, width: 100, height: 140, pileStyle: "basic" },
        "cut": { x: 130, y: 250, offsetX: 8, offsetY: 0, pileStyle: "basic" },
        "cut1": { x: 400, y: 420, offsetX: 2, offsetY: 0, pileStyle: "basic" },
        "cut2": { x: 400, y: 80, offsetX: 2, offsetY: 0, pileStyle: "basic" },
        "cribbageBoard": { x: 600, y: 0, r: 0, width: 200, height: 500, orientation: "vertical", zOrder: -90 },
        "buttonConfirm": { x: 265, y: 220 },
        "playCount": { x: 560, y: 180 + 40, zOrder: 100, scale: 0.5 },
        "profile1": { x: 80, y: 350 },
        "profile2": { x: 80, y: 10 },
        "player1Disconnected": { x: 80 + 3, y: 350 + 3, width: 30, height: 30 },
        "player2Disconnected": { x: 80 + 3, y: 10 + 3, width: 30, height: 30 },
        "player1TurnTimer": { x: 80, y: 350 + 145 },
        "player2TurnTimer": { x: 80, y: 10 + 145 },
        "player1TurnIndicator": { x: 80, y: 350 },
        "player2TurnIndicator": { x: 80, y: 10 },
        "chatBubble1": { x: 80 + 80, y: 330, zOrder: 210 },
        "chatBubble2": { x: 80 + 80, y: 30, zOrder: 210 },
        "instructions1": { x: 385, y: 325, zOrder: 100, scale: 0.5, zOrder: 200 },
        "instructions2": { x: 385, y: 155, zOrder: 100, scale: 0.5, zOrder: 200 },
        "invalidMove1": { x: 400, y: 485, zOrder: 100, scale: 0.5 },
        "invalidMove2": { x: 400, y: -15, zOrder: 100, scale: 0.5 },
        "textPopUpMessage1": { x: 400, y: 350 + 60, zOrder: 200 },
        "textPopUpMessage2": { x: 400, y: 10 + 60, zOrder: 200 },
        "buttonExit": { x: 10, y: 10, width: 60, height: 60 },
        "buttonChat": { x: 10, y: 500 - 10 - 60, width: 60, height: 60 },
        "buttonAudio": { x: 10, y: 500 - 10 - 60 - 10 - 60, width: 60, height: 60 },
        "buttonAudioMute": { x: 10, y: 500 - 10 - 60 - 10 - 60, width: 60, height: 60 },
        "roundSummary": { x: 205, y: 160, zOrder: 200 },
        "roundOver": { x: 205, y: 240, zOrder: 200 },
        "chatMute": { x: 80, y: 120, width: 30, height: 30 },
        "buttonAddFriend": { x: 80, y: 155, scale: 0.5 },
        "buttonReport": { x: 133, y: 155, scale: 0.5 },
        "buttonProfileDetails":{ x: 105, y: 153, scale: 0.5 },
        "gameOver": { x: 200, y: 210, zOrder: 200 },
        "buttonReady": { x: 265, y: 220 },
    };